export const setWorstFilter = () => ({
    type: 'SET_WORST_FILTER'
});

export const setLatestFilter = () => ({
    type: 'SET_LATEST_FILTER'
});
